import { getWindow } from "src/utility/window";

function initSessionStorage() {
  const test = "__test__";
  // we hide global sessionStorage member to encourage use of this
  // helper; we access it directly in this helper only
  const window = getWindow() as { sessionStorage: Storage } | undefined;
  if (window) {
    try {
      window.sessionStorage.setItem(test, test);
      window.sessionStorage.removeItem(test);
      return window.sessionStorage;
    } catch (e) {
      return undefined;
    }
  }
  return undefined;
}

const sessionStorage = initSessionStorage();

export function getSessionStorage() {
  return sessionStorage;
}
